(() => {
  const clean = (q) => {
    if (q.startsWith('(title:') && q.endsWith(' AND -tag:EP')) {
      return q.slice(0, -12).split(' AND ').map(part => part.split(' OR ')[0].slice(7)).join(' ');
    }
    return q.replace(/\s+(?:AND\s+)?-tag:EP\s*$/, '').replace(/^\((.*)\)$/s, '$1').trim();
  };
  const filter = (q) => {
    if (q.startsWith('(title:') && q.endsWith(' AND -tag:EP')) return q;
    const term = clean(q);
    if (!term) return '';
    if (/^id:\d+( OR id:\d+)*$/.test(term)) return `(${term}) AND -tag:EP`;
    const words = term.replace(/[():"\\*]/g, ' ').split(/\s+/).filter(Boolean);
    if (!words.length) return '';
    return words.map(word => `(title:${word} OR body:${word} OR variants.title:${word} OR variants.sku:${word})`).join(' AND ') + ' AND -tag:EP';
  };
  window.apexSearchQuery = filter;
  const searchPath = document.documentElement.dataset.searchPath;
  const current = new URL(location.href);
  if (current.pathname === searchPath && current.searchParams.get('q')) {
    const q = filter(current.searchParams.get('q'));
    if (q !== current.searchParams.get('q') || current.searchParams.get('type') !== 'product') {
      current.searchParams.set('q', q);
      current.searchParams.set('type', 'product');
      location.replace(current.href);
    }
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || new URL(form.action, location.href).pathname !== searchPath) return;
    const data = new FormData(form);
    const url = new URL(form.action, location.href);
    for (const [key, value] of data) if (typeof value === 'string') url.searchParams.set(key, value);
    url.searchParams.set('q', filter(String(data.get('q') || '')));
    url.searchParams.set('type', 'product');
    event.preventDefault();
    location.assign(url.href);
  }, true);
})();
